import UserFieldBase from "./base";

export default class UserFieldDropdown extends UserFieldBase {}
